/**
 * T15407 · Platform · screenFocus — web no-op-via-useEffect.
 *
 * On web, DOM mount ⇔ visible: when a route's components are mounted
 * they are by definition focused (no parallel-mounted-but-blurred sibling
 * state to worry about). The slot's `useFocusEffect` therefore reduces to
 * a plain `useEffect(() => effect(), [effect])` — effect runs on mount,
 * cleanup on unmount.
 *
 * MUST NOT import `@react-navigation/native` — that package's conditional
 * exports don't resolve under web bundlers (Metro vs. webpack), and
 * pulling it in here would surface as a hard build break.
 */
import * as React from 'react';
export function createWebScreenFocusSlot() {
  return {
    useFocusEffect(effect) {
      // The dependency array is intentionally [effect] — when the
      // caller stabilises the callback via useCallback the effect
      // runs once; if the caller passes an unstable function the
      // effect re-runs (mirroring @react-navigation's contract).
      React.useEffect(() => effect(), [effect]);
    }
  };
}